import clsx from 'clsx'

/**
 * Three rings, spinning at different speeds and in alternating directions,
 * each showing colour only on its top edge — the classic "orbital" spinner.
 *
 * Ported from a shadcn/TypeScript/Framer Motion original into this project's
 * own stack (plain JS, Tailwind, CSS @keyframes) rather than pulled in as-is:
 * this app has no shadcn project structure, no TypeScript, and no existing
 * use for an animation library, so adding all three just to get one spinner
 * would be a bigger change than the spinner itself. The visual design and the
 * `message`/`messagePlacement` API are kept the same.
 */

const PLACEMENT_CLASSES = {
  bottom: 'flex-col',
  top: 'flex-col-reverse',
  right: 'flex-row',
  left: 'flex-row-reverse',
}

export function OrbitalLoader({ className, message, messagePlacement = 'bottom' }) {
  return (
    <div className={clsx('flex items-center justify-center gap-2', PLACEMENT_CLASSES[messagePlacement])}>
      <div className={clsx('relative h-16 w-16', className)} role="status" aria-live="polite">
        <span className="sr-only">Loading</span>

        <div
          aria-hidden="true"
          className="absolute inset-0 rounded-full border-2 border-transparent"
          style={{
            borderTopColor: 'var(--color-accent)',
            animation: 'orbital-spin-cw 1s linear infinite',
          }}
        />
        <div
          aria-hidden="true"
          className="absolute inset-2 rounded-full border-2 border-transparent"
          style={{
            borderTopColor: 'var(--color-accent)',
            animation: 'orbital-spin-ccw 1.5s linear infinite',
          }}
        />
        <div
          aria-hidden="true"
          className="absolute inset-4 rounded-full border-2 border-transparent"
          style={{
            borderTopColor: 'var(--color-accent)',
            animation: 'orbital-spin-cw 0.8s linear infinite',
          }}
        />
      </div>

      {message && <div className="text-sm text-[var(--color-ink-500)]">{message}</div>}
    </div>
  )
}

export default OrbitalLoader
